import { render, staticRenderFns } from "./CartModule.vue?vue&type=template&id=164d34d0&lang=pug"
import script from "./CartModule.vue?vue&type=script&lang=js"
export * from "./CartModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports